import { render, staticRenderFns } from "./addPointWorkDialog.vue?vue&type=template&id=04a323ba&scoped=true"
import script from "./addPointWorkDialog.vue?vue&type=script&lang=js"
export * from "./addPointWorkDialog.vue?vue&type=script&lang=js"
import style0 from "./addPointWorkDialog.vue?vue&type=style&index=0&id=04a323ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a323ba",
  null
  
)

export default component.exports